function getQueryVariable(variable) {
	var query = window.location.href.split('#')[1].substring(1)
	var vars = query.split('&')
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=')
		if (pair[0] == variable) {
			return pair[1]
		}
	}
	return false
}

/**
 * 数据库名称：登录界面会初始化这个本地浏览器session对象。
 * 数据库名拟使用工厂名称命名。数据同步到公有云时，可直接按库名进行工厂级别的数据同步。此字段需要在公有云 mysql 中建表维护，全局唯一。
 */
export function getDBName() {
	var factory = getQueryVariable('factory')
	if (factory) return factory

	return localStorage.getItem('database')!
}

/**
 * restHeart服务器地址，本地开发时为 .env.development 中设置的值。
 * 部署生产环境时，请在 .env.production 中定义。详情参考 https://cli.vuejs.org/zh/guide/mode-and-env.html
 */
export const restHeartOrigin = process.env.VUE_APP_REST_HEART_ORIGIN
